var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "make-invoice-adjust-balance-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: this.$t("CargoMsg.Cargo_NewTo"),
            width: "380px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                { attrs: { "label-width": "90px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: this.$t("CargoMsg.Cargo_Carrier") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            companyLob: "seaExport",
                            seaCmp: true,
                            active: true
                          },
                          "default-value": _vm.form.carrierId || "",
                          "callback-params": { key: "carrierId" }
                        },
                        on: {
                          parentCallBack: function(p) {
                            return _vm.onCompanyChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: this.$t("CargoMsg.Cargo_GenerativeRule") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { disabled: true },
                          model: {
                            value: _vm.form.generativeRule,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "generativeRule", $$v)
                            },
                            expression: "form.generativeRule"
                          }
                        },
                        _vm._l(_vm.generativeRules, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: this.$t("CargoMsg.Cargo_ApplicableBranch"),
                        disabled: false
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "branchId",
                          "select-type":
                            _vm.selectTypeNames.basic_data_Office_All,
                          clearable: false,
                          filterable: "",
                          "default-value": _vm.form.branchId || "",
                          cache: false,
                          "static-options": _vm.officeList,
                          placeholder: " "
                        },
                        on: {
                          parentCallBack: function(p) {
                            return _vm.handleCompany(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: this.$t("CargoMsg.ApplicableDepartment") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "departmentId",
                          "select-type":
                            _vm.selectTypeNames.basic_data_Department,
                          "allow-create": true,
                          filterable: "",
                          cache: false,
                          "static-options": _vm.departmentArray
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.form.department = p.departmentId
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editMblNoMode === 3,
                          expression: "editMblNoMode === 3"
                        }
                      ],
                      attrs: { label: this.$t("CargoMsg.Cargo_OrderChannel") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "channel",
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_SystemConstants$CHANNEL_LIST,
                          filterable: "",
                          multiple: true,
                          "default-multiple-value": _vm.form.channelList,
                          "tag-name": "englishName",
                          "tag-value": "englishName"
                        },
                        on: {
                          parentCallBack: function(p) {
                            return _vm.handleChange(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: this.$t("SeaExport.StartMbl") } },
                    [
                      _c("el-input", {
                        attrs: { no: "startMbl" },
                        model: {
                          value: _vm.form.startMbl,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "startMbl", $$v)
                          },
                          expression: "form.startMbl"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: this.$t("CargoMsg.Cargo_MblNo") } },
                    [
                      _c("process-file", {
                        attrs: { "file-list": _vm.fileList }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "right" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.downloadHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DownLoad_Template")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.saveHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.innerVisible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }